import { render, staticRenderFns } from "./stepsFourPledge.vue?vue&type=template&id=340aba32&scoped=true"
import script from "./stepsFourPledge.vue?vue&type=script&lang=js"
export * from "./stepsFourPledge.vue?vue&type=script&lang=js"
import style0 from "./stepsFourPledge.vue?vue&type=style&index=0&id=340aba32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340aba32",
  null
  
)

export default component.exports